import React from "react";
import { AnimateIn, StaggerIn } from "./AnimateIn";
import "./Testimonials.css";

const valueIcons = [
  // Less false-start searching
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  // Faster first-pass review
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  // Better internal alignment
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
];

export const Testimonials = ({ data }) => {
  if (!data) return null;

  return (
    <section id="value" className="value-section">
      <div className="section-container">
        <AnimateIn variant="fadeUp">
          <div className="value-header">
            <p className="eyebrow">{data.eyebrow}</p>
            <h2 className="section-title">{data.title}</h2>
          </div>
        </AnimateIn>
        <StaggerIn variant="scaleUp" stagger={0.12} className="value-grid">
          {data.items.map((item, i) => (
            <div key={i} className="value-card">
              <div className="value-icon">{valueIcons[i]}</div>
              <h3 className="value-name">{item.title}</h3>
              <p className="value-desc">{item.description}</p>
            </div>
          ))}
        </StaggerIn>
      </div>
    </section>
  );
};
